import React from "react";
import MainButton from "../../../ui/main-button";
import { AppColors } from "../../../utils/global-constants";

const HomeTop = ({ currentUser, logout }) => {
  return (
    <div className="home-top-wrapper">
      <div>
        <div className="home-top-wrapper-user-info">
          <img
            src={currentUser.avatar}
            alt="user"
            className="home-top-wrapper-user-avatar"
          />
          <p style={{ color: AppColors.white }}>
            Welcome, {currentUser.nickname}
          </p>
          <p style={{ color: AppColors.main }}>
            ${parseFloat(currentUser.coins).toFixed(2)}
          </p>
        </div>
      </div>
      <MainButton
        text="Logout"
        className="home-top-wrapper-logout"
        onClick={logout}
      />
    </div>
  );
};

export default HomeTop;
